import React from 'react';
import Header2 from './../Common/Header2';
import Footer2 from './../Common/Footer2';
import Banner from './../Elements/Banner';
import SEO from './../Common/SEO';

var bnrimg = require('./../../images/banner/4.jpg');

function PrivacyPolicy() {
return (
<> <SEO
     title="Privacy Policy | Infrio India"
     description="Privacy Policy for Infrio India."
     canonicalPath="/privacy-policy"
   />


  <Header2 />

  <div className="page-content">
    <Banner
      title="Privacy Policy"
      pagename="Privacy Policy"
      description="How we collect and use your information."
      bgimage={bnrimg}
    />

    <div className="section-full p-t80 p-b80 mobile-page-padding">
      <div className="container">
        <div
          className="bg-white p-a40"
          style={{
            borderRadius: "10px",
            boxShadow: "0 0 20px rgba(0,0,0,0.08)"
          }}
        >
          <h2 className="m-b20">Privacy Policy</h2>

          <p>
            Infrio India respects your privacy and is committed to
            protecting your personal information.
          </p>

          <h4>Information We Collect</h4>
          <ul>
            <li>Name</li>
            <li>Email Address</li>
            <li>Phone Number</li>
            <li>Project Information</li>
          </ul>

          <h4>How We Use Information</h4>
          <ul>
            <li>Respond to enquiries.</li>
            <li>Provide architectural and construction services.</li>
            <li>Improve customer experience.</li>
            <li>Send project updates.</li>
          </ul>

          <h4>Cookies</h4>
          <p>
            Our website may use cookies to improve functionality and
            user experience.
          </p>

          <h4>Data Security</h4>
          <p>
            We implement appropriate security measures to protect
            personal information.
          </p>

          <h4>Third Party Websites</h4>
          <p>
            We are not responsible for privacy practices of external
            websites linked from our platform.
          </p>

          <h4>Contact Information</h4>
          <p>
            Email: info@infrioindia.com <br />
            Phone: +91 9001457000
          </p>
        </div>
      </div>
    </div>
  </div>

  <Footer2 />
</>


);
}

export default PrivacyPolicy;
